/**
 * Tenant ids that use the Advasco ticket system. Kept free of imports so
 * import-sensitive bundles (Neptune's content script) can read it without
 * pulling in UI libraries; advascoTicket.ts re-exports it.
 */
export const ADVASCO_TENANT_IDS = new Set<string>([
  "3a50cc63-295c-4730-b7cd-b148c9382700", // Kramer-Werke GmbH (prod)
  // add the Kramer staging tenant id here when testing on staging
]);
